/* global  */ // tUrl等のグローバル変数を宣言する
import './_smoothScroll' // スムーズスクロール
// import Swiper from 'swiper' // Swiper
// import PerfectScrollbar from 'perfect-scrollbar' // 独自スクロールバー
// position:styckyのポリフィル
// Stickyfill.add(document.querySelectorAll('.sticky'))

jQuery(function($) {
  let accBtn = 'sp-menu' // このIDを基準としたアコーディオン
  $('#' + accBtn + '-open,.' + accBtn + '-close,#' + accBtn + ' a,#overlay').on('click', function() {
    $('#' + accBtn + ',#' + accBtn + '-open,.' + accBtn + '-close').toggleClass('active')
  })

  function trunk8() {
    $('.js-t8.line4').trunk8({
      // 指定要素に行数制限をかける
      lines: 4,
      fill: '...'
    })
    $('.js-t8.line3').trunk8({
      // 指定要素に行数制限をかける
      lines: 3,
      fill: '...'
    })
    $('.js-t8.line2').trunk8({
      // 指定要素に行数制限をかける
      lines: 2,
      fill: '...'
    })
    $('.js-t8.line1').trunk8({
      // 指定要素に行数制限をかける
      lines: 1,
      fill: '...'
    })
  }
  if ($('.js-t8')[0]) {
    // 要素を検出したら実行
    trunk8()
    $('.js-t8').removeAttr('title')
    $(window).on('load resize ', function() {
      trunk8()
      $('.js-t8').removeAttr('title')
    })
  }

  //--------------------
  // トップへ戻るボタン設定
  //--------------------
  const breakpoint = 750
  $(document).ready(function() {
    // 120を超えたら表示させる
    const topBtn = $('#page_top')
    topBtn.hide()
    $(window).scroll(function() {
      if ($(this).scrollTop() > 120) {
        topBtn.fadeIn()
      } else {
        topBtn.fadeOut()
      }
    })
    // 動きをスムーズに
    topBtn.click(function () {
      $('body,html').animate({
        scrollTop: 0
      }, 500)
      return false
    })
  })

  $(function() {
    $(window).scroll(function(e) {
      const windowWidth = window.innerWidth               //ウィンドウ幅を取得
      const height = $(e.currentTarget).height()     //ウィンドウ(ブラウザ)の高さ
      const scrollTop = $(e.currentTarget).scrollTop() //スクロール量
      const documentHeight = $(document).height()            //ページ全体の高さ
      const footerHeight = $('#footer').height()           //フッタの高さ

      const bottomY = 10  //スクロール時の下からの位置
      let imgHeight = 88  //戻るボタンの高さ
      if (windowWidth <= breakpoint) {	//スマフォ時
        imgHeight = 60
      }

      const bottomHeight = footerHeight + height + scrollTop + bottomY - documentHeight - imgHeight - 55

      if (scrollTop >= documentHeight - height - footerHeight + bottomY) {
        if (windowWidth <= breakpoint) {	//スマフォ時
          $('#page_top').css({ bottom: bottomY })
        } else {
          $('#page_top').css({ bottom: bottomHeight - bottomY }) //スクロール時にbottomの値が変動
        }
      } else {
        $('#page_top').css({ bottom: bottomY })
      }
    })
  })

  //--------------------
  // ナビメニュー
  //--------------------
  $(function () {
    const $header = $('#top-head')
    // Nav Toggle Button
    $('#nav-toggle').click(function () {
      $header.toggleClass('open')
    })
  })

  //--------------------
  // セレクトメニューでリンク飛ぶ
  //--------------------
  // function dropsort() {
  //   const browser = document.sort_form.sort.value
  //   location.href = browser
  // }

  //--------------------
  // スライダー設定
  //--------------------
  $(function() {
    $('.thumb-item').slick({
      infinite: true,
      autoplay: true,
      autoplaySpeed: 3000,
      speed: 2000,
      swipeToSlide: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      fade: true,
      asNavFor: '.thumb-item-nav',
      responsive: [ //レスポンシブの設定
        {
          breakpoint: breakpoint, //ブレークポイント
          settings: {
            arrows: true,
            fade: false
          }
        }
      ]
    })
    $('.thumb-item-nav').slick({
      accessibility: false,
      autoplay: true,
      autoplaySpeed: 3000,
      speed: 2000,
      arrows: false,
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      asNavFor: '.thumb-item',
      focusOnSelect: true,
      vertical: true,
      responsive: [ //レスポンシブの設定
        {
          breakpoint: 750, //ブレークポイント
          settings: 'unslick' //slickを使わない
        }
      ]
    })
    $('.thumb-bana-item_1').slick({
      infinite: true,
      autoplay: true,
      autoplaySpeed: 3000,
      speed: 2000,
      swipeToSlide: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: false,
      responsive: [ //レスポンシブの設定
        {
          breakpoint: breakpoint, //ブレークポイント
          settings: {
            arrows: true,
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    })
    $('.thumb-bana-item_2').slick({
      infinite: true,
      autoplay: true,
      autoplaySpeed: 3000,
      speed: 2000,
      swipeToSlide: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: false,
      responsive: [ //レスポンシブの設定
        {
          breakpoint: breakpoint, //ブレークポイント
          settings: {
            arrows: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: '5px',
            variableWidth: true
          }
        }
      ]
    })

    $('.thumb-item-md_1').slick({
      infinite: true,
      autoplay: true,
      autoplaySpeed: 3000,
      speed: 2000,
      swipeToSlide: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      fade: true,
      asNavFor: '.thumb-item-md-nav_1',
      responsive: [ //レスポンシブの設定
        {
          breakpoint: breakpoint, //ブレークポイント
          settings: {
            arrows: true
          }
        }
      ]
    })
    $('.thumb-item-md-nav_1').slick({
      accessibility: false,
      autoplay: false,
      arrows: false,
      dots: false,
      slidesToShow: 3,
      slidesToScroll: 3,
      swipeToSlide: false,
      asNavFor: '.thumb-item-md_1',
      focusOnSelect: true,
      vertical: true,
      fade: false,
      infinite: false,
      responsive: [ //レスポンシブの設定
        {
          breakpoint: breakpoint, //ブレークポイント
          settings: 'unslick' //slickを使わない
        }]
    })

    $('.thumb-item-md_2').slick({
      infinite: true,
      autoplay: true,
      autoplaySpeed: 2000,
      speed: 1000,
      swipeToSlide: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      fade: true,
      asNavFor: '.thumb-item-md-nav_2',
      responsive: [ //レスポンシブの設定
        {
          breakpoint: breakpoint, //ブレークポイント
          settings: {
            arrows: true
          }
        }
      ]
    })
    $('.thumb-item-md-nav_2').slick({
      accessibility: false,
      autoplay: false,
      arrows: false,
      dots: false,
      slidesToShow: 3,
      slidesToScroll: 3,
      swipeToSlide: false,
      asNavFor: '.thumb-item-md_2',
      focusOnSelect: true,
      vertical: true,
      fade: false,
      infinite: false,
      responsive: [ //レスポンシブの設定
        {
          breakpoint: breakpoint, //ブレークポイント
          settings: 'unslick' //slickを使わない
        }
      ]
    })
  })
})
